import { PropsWithChildren } from 'react'

import { Flex } from 'antd'

import { ButtonGroupProps } from './interface'

export const ButtonGroup = ({
  orientation = 'vertical',
  align = 'center',
  justify = 'start',
  children
}: PropsWithChildren<ButtonGroupProps>) => {
  return (
    <Flex
      wrap
      align={align}
      gap={0}
      justify={justify}
      vertical={orientation === 'vertical'}
    >
      {children}
    </Flex>
  )
}
